<template>
  <div>
    <b-input-group>
    <input
      class="form-control col-md-12"
      v-model="value"
      required="required"
      :type="fieldType"
      :disabled="disabled"
      :maxlength="schema.max"
      :id="getFieldID(schema)"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      :name="schema.inputName"
      v-bind="schema.options"
      v-on:keyup="format()"
    >
    <b-input-group-append v-show="value">
        <b-button @click="toggleType">
          <font-awesome-icon :icon="icon" title="Click to view SSN input."/>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>

</template>

<script>
import { abstractField } from 'vue-form-generator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

library.add([faEye, faEyeSlash]);

export default {
  mixins: [abstractField],
  data() {
    return {
      fieldType: 'password',
    };
  },
  computed: {
    icon() {
      return this.fieldType === 'password' ? 'eye' : 'eye-slash';
    },
  },
  methods: {
    toggleType() {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
    format() {
      const formattedValue = this.value.replace(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/g, '');
      if (formattedValue) {
        this.value = this.formatSocialSecurity(formattedValue);
      }
    },
    formatSocialSecurity(value) {
      let strValue = value;
      strValue = value.replace(/\D/g, '');
      strValue = strValue.replace(/^(\d{3})/, '$1-');
      strValue = strValue.replace(/-(\d{2})/, '-$1-');
      strValue = strValue.replace(/(\d)-(\d{4}).*/, '$1-$2');
      return strValue;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldSmartSsn.vue